import { render, staticRenderFns } from "./OrderMemo.vue?vue&type=template&id=f6373038&"
import script from "./OrderMemo.vue?vue&type=script&lang=js&"
export * from "./OrderMemo.vue?vue&type=script&lang=js&"
import style0 from "./OrderMemo.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports